import { watch, ref } from 'vue'
import { isString } from '@/utils/is'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useI18n } from '@/hooks/web/useI18n'
import { useCommonStoreWithOut } from '@/store/modules/common'

const appStore = useAppStoreWithOut()
const comminStore = useCommonStoreWithOut()

export const useTitle = (newTitle?: string) => {
  const { t } = useI18n()
  const title = ref(
    newTitle ? `${appStore.getTitle} - ${t(newTitle as string)}` : appStore.getTitle
  )

  watch(
    title,
    (n, o) => {
      // 如果自定义了就不动态修改了
      if (comminStore.portalPageSetting && comminStore.portalPageSetting.isenable && comminStore.portalPageSetting.tab_text) {
        document.title = comminStore.portalPageSetting.tab_text
        return
      }
      if (isString(n) && n !== o && document) {
        document.title = n
      }
    },
    { immediate: true }
  )

  return title
}
